import Repository from '../axios'
import {defaultPagination} from "@/constants/config";

const  resource = "/landlord/tenants";

export default {
  get(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/account/list?limit=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getLocationList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort, account_id = '') {
    return Repository.get(`/location/list?limit=${pagination}&page=${pageNumber}&${filterQuery}&account_id=${account_id}`)
  },
  getBuildingList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort, account_id = '') {
    return Repository.get(`/building/list?limit=${pagination}&page=${pageNumber}&${filterQuery}&account_id=${account_id}`)
  },
  getContactList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort, account_id = '') {
    return Repository.get(`/contact/list?limit=${pagination}&page=${pageNumber}&${filterQuery}&account_id=${account_id}`)
  },
  getActionList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort, account_id = '') {
    return Repository.get(`/action/list?limit=${pagination}&page=${pageNumber}&${filterQuery}&account_id=${account_id}`)
  },
  getPropertyRiskAssessmentList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort, account_id = '') {
    return Repository.get(`/propertyRiskAssessment/list?limit=${pagination}&page=${pageNumber}&${filterQuery}&account_id=${account_id}`)
  },
  getBrewerySiteInspectionList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort, account_id = '') {
    return Repository.get(`/brewerySiteInspection/list?limit=${pagination}&page=${pageNumber}&${filterQuery}&account_id=${account_id}`)
  },
  getCopeAssessmentList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort, account_id = '') {
    return Repository.get(`/copeAssessment/list?limit=${pagination}&page=${pageNumber}&${filterQuery}&account_id=${account_id}`)
  },
  getHazardInspectionList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort, account_id = '') {
    return Repository.get(`/hazardInspection/list?limit=${pagination}&page=${pageNumber}&${filterQuery}&account_id=${account_id}`)
  },
  getFoodSafetyReportList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort, account_id = '') {
    return Repository.get(`/foodSafetyReport/list?limit=${pagination}&page=${pageNumber}&${filterQuery}&account_id=${account_id}`)
  },
  getStandardActionList(pageNumber = 1, filterQuery, pagination = defaultPagination, sort) {
    return Repository.get(`/standardAction/list?limit=${pagination}&page=${pageNumber}&${filterQuery}`)
  },
  getTenantDetails(id){
    return Repository.get(`${resource}/${id}`)
  },
  resendTenantUsersWelcomeEmail(email) {
    return Repository.put(`/landlord/tenant/${email}/resend_welcome_email`)
  },
  resendTenantStaffUserWelcomeEmail(tenant_id, email) {
    return Repository.put(`/landlord/tenant/${tenant_id}/staff-user/${email}/staff-resend`)
  },
  //assessment buildings
  getAssessmentBuildings(assessment_type, assessment_id) {
    return Repository.get(`/building/assessment/${assessment_type}/${assessment_id}`)
  },
  //remove building from assessment
  removeBuildingFromAssessment(building_id) {
    return Repository.delete(`/building/assessment/buildings/${building_id}`)
  },

  //property risk assessment attachments 
  getAttachments(endpoint, object_id) {
    return Repository.get(`/${endpoint}/${object_id}/attachments`)
  },
  deleteAttachments(endpoint, object_id, attachment_id) {
    return Repository.delete(`/${endpoint}/${object_id}/attachments/${attachment_id}`)
  },
  uploadAttachment(endpoint, object_id, payload, screen = '') {
    return Repository.post(`/${endpoint}/${object_id}/attachments?screen=${screen}`, payload, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  uploadDocumentForAiEngine(file) {
    return Repository.post(`/admin/attachments`, file, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },
  generatePdfTest() {
    return Repository.get(`/admin/generate-pdf`, {
      responseType: 'blob'
    })
  }
};
